var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopoverleftarrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H26C27.1046 0 28 0.895431 28 2V24C28 25.1046 27.1046 26 26 26H8C3.58172 26 0 22.4183 0 18V8Z",
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19915_81510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7631 14.1512C13.3726 13.7607 13.3726 13.1275 13.7631 12.737L16.0279 10.4722C16.35 10.1501 16.35 9.62774 16.0279 9.30557C15.7057 8.98341 15.1834 8.98341 14.8612 9.30557L11.4298 12.737C11.0392 13.1275 11.0392 13.7607 11.4298 14.1512L14.8612 17.5827C15.1834 17.9048 15.7057 17.9048 16.0279 17.5827C16.35 17.2605 16.35 16.7382 16.0279 16.416L13.7631 14.1512Z",
    fill: "#424446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19915_81510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8889,
    height: 7,
    fill: "white",
    transform: "matrix(0 -1 1 0 10 18.8887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverleftarrow);
export default __webpack_public_path__ + "static/media/popoverleftarrow.bd7fff56b78cb3ce32ac8bf6cb1280cd.svg";
export { ForwardRef as ReactComponent };